import React from "react";
import { useLocation } from "react-router-dom";

export function AnalyticsProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = () => {
      gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href
      });
    };

    // Track on mount (initial page load)
    trackPageView();

    // Track on location changes
    return () => {
      trackPageView();
    };
  }, [location]);

  return children;
}

// Custom hook for tracking events
export function useAnalytics() {
  const trackEvent = (action, category, label = null, value = null) => {
    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  };

  return { trackEvent };
}
